// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__3tgBh","label":"SetPasswdForm_label__Y-ERw"};